var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "material-symbols:arrow-right-rounded"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.58696 12.5756C6.10507 13.0146 5.5537 13.113 4.93283 12.8709C4.31196 12.6287 4.00101 12.1952 4 11.5704V4.43024C4 3.80635 4.31094 3.37286 4.93283 3.12977C5.55471 2.88668 6.10609 2.98512 6.58696 3.42508L10.5435 7.02981C10.6957 7.16846 10.8098 7.31865 10.8859 7.4804C10.962 7.64216 11 7.81546 11 8.00032C11 8.18518 10.962 8.35848 10.8859 8.52023C10.8098 8.68198 10.6957 8.83218 10.5435 8.97082L6.58696 12.5756Z",
    fill: "#FCFCFC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.f9061928bf014f8a9652cc29ddc23bab.svg";
export { ForwardRef as ReactComponent };